/**
 * Auto-opens the Back in Stock ("Notify me when available") popup when a
 * sold-out variant is selected. Listens for the theme's on:variant:change
 * event and clicks the Back in Stock app's notify button, which the app
 * injects client-side for unavailable variants.
 */
(() => {
  const NOTIFY_TEXT = 'notify me when available';

  const findNotifyTrigger = (scope) => {
    const root = scope || document;
    const candidates = root.querySelectorAll('button, a, [role="button"]');
    for (const el of candidates) {
      const text = (el.textContent || '').trim().toLowerCase();
      if (text.includes(NOTIFY_TEXT) && el.offsetParent !== null) return el;
    }
    return null;
  };

  const popupIsOpen = () => !!document.querySelector(
    '.BIS_modal, .bis-modal, [class*="back-in-stock"][class*="modal"], [id*="back_in_stock"][aria-modal="true"]'
  );

  const tryOpen = (scope, attempt) => {
    if (popupIsOpen()) return;
    const trigger = findNotifyTrigger(scope);
    if (trigger) {
      trigger.click();
    } else if (attempt < 12) {
      setTimeout(() => tryOpen(scope, attempt + 1), 150);
    }
  };

  document.addEventListener('on:variant:change', (event) => {
    const detail = event.detail || {};
    const variant = detail.variant;
    if (!variant || variant.available) return;
    if (popupIsOpen()) return;

    const scope = (detail.form && detail.form.closest('.product')) || document;
    tryOpen(scope, 0);
  });
})();
